import script from "./CtrlDespacho.vue?vue&type=script&lang=ts&setup=true"
export * from "./CtrlDespacho.vue?vue&type=script&lang=ts&setup=true"

import "./CtrlDespacho.vue?vue&type=style&index=0&id=01d9d8f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01d9d8f2"]])

export default __exports__